<template>
  <div
    ref="rtListFilter"
    :class="classes"
  >
    <div class="normal">
      <slot />
      <div class="no-padding">
        <slot name="bottom" />
      </div>
      <div class="filter-btns-container">
        <div class="filter-btns">
          <slot name="btns" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtListFilter',
  data () {
    return {
      hasPaddingBottom: false,
      observer: null
    };
  },
  computed: {
    classes () {
      return [
        'rt-list-filter',
        {
          'padding-size-bottom': this.hasPaddingBottom
        }
      ];
    },
    hasBottom () {
      return this.$slots.bottom;
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.reLayout();
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
      // 判断浏览器是否支持监听DOM变化
      if (MutationObserver) {
        if (this.$refs.rtListFilter.querySelector('form')) {
          const self = this;
          const callback = function (mutationsList) {
            let isChange = false;
            // eslint-disable-next-line
            for (let mutation of mutationsList) {
              if (mutation.type === 'childList') {
                isChange = true;
              }
            }
            if (isChange) self.reLayout();
          };
          this.observer = new MutationObserver(callback);
          this.observer.observe(this.$refs.rtListFilter.querySelector('form'), {
            childList: true,
            subtree: true
          });
        }
      }
    });
  },
  beforeDestroy () {
    this.observer && this.observer.disconnect();
  },
  methods: {
    reLayout () {
      let $form = this.$refs.rtListFilter.querySelector('form');
      let $lastrow = $form ? $form.lastElementChild : null;
      if ($lastrow) {
        let children = $lastrow.children;
        let spans = Array.from(children).reduce((acc, item) => {
          let span = Array.from(item.classList)
            .join(',')
            .match(/el-col-(\d+)/)[1];
          return Number(span) + acc;
        }, 0);
        this.hasPaddingBottom = (spans && Number(spans) % 24 === 0) || this.hasBottom;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListFilter.vue?211dd31a